/**
 * ステップの間隔と最大値からY軸の極大値を求める
 * @param {number} max - 最大値
 * @param {number} stepSize - ステップの間隔
 * @returns {number}
 */
export default function getMaxLimit(max, stepSize) {
  return Math.ceil((max + 1) / stepSize) * stepSize
}
